import React from 'react';
import { Link } from 'react-router-dom';
import { EyeOutlined } from '@ant-design/icons';
import { theme } from 'antd';
import sitelinks from 'constants/sitelinks';

const ViewDriverButton = ({ driverId }: { driverId: string | number }) => {
  const { token } = theme.useToken();
  return (
    <Link to={`${sitelinks.paquers.list}/${driverId}`} title="Ver Driver">
      <EyeOutlined style={{ color: token.colorPrimary, fontSize: 18 }} />
    </Link>
  );
};

export default ViewDriverButton;
